import { action, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { ProductPartForm } from 'modules/product/forms';
import { MultiPackageProductStore } from 'modules/product/stores';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';

class UpdateProductPartModalContentViewStore extends BaseViewStore {
	updateProductPartForm = new ProductPartForm({
		onSuccess: async () => {
			await this.updateProductPart();
		},
	});

	constructor(rootStore, componentProps) {
		super(rootStore);
		makeObservable(this);
		this.parentView = this.rootStore.productDetailViewStore;
		this.multiPackageProductStore = new MultiPackageProductStore(rootStore);
		this.selectedProductPart = componentProps.selectedProductPart;
		this.initialize();
	}

	@action initialize = async () => {
		this.updateProductPartForm.state.options.set({
			validateOnChange: true,
		});
		this.updateProductPartForm.$('product').value = this.selectedProductPart.productId;
	};

	@action.bound updateProductPart = async () => {
		const { product, quantity } = this.updateProductPartForm.values();

		const multiPackageProduct = {
			id: this.selectedProductPart.id,
			parentProductId: this.rootStore.routerStore.routerState.params.id,
			productId: product,
			quantity,
		};

		await this.multiPackageProductStore.update(multiPackageProduct, sourceOfChange.updateProductCombination);
		this.rootStore.notificationStore.success('PRODUCTDETAILVIEW.UPDATEPRODUCTPARTMODAL.PRODUCTPARTUPDATESUCCESS');
		this.parentView.updateProductPartModal.close();
		this.parentView.initialize();
	};
}

export default UpdateProductPartModalContentViewStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/UpdateProductPartModalContentViewStore.js